import Vue from "vue";
import Router from "vue-router";
import { loginState } from "./util/login";
let Login = () => import("./views/Login.vue");
let Main = () => import("./views/Main.vue");
let AdminList = () => import("./views/AdminList.vue");
let ForwardList = () => import("./views/ForwardList.vue");
let ForwardFinishList = () => import("./views/ForwardFinishList.vue");
let HouseList = () => import("./views/HouseList.vue");
let PurchaserList = () => import("./views/PurchaserList.vue");
let ForwardPreview0 = () => import("./views/ForwardPreview0.vue");
let ForwardPreview1 = () => import("./views/ForwardPreview1.vue");
let PdfPreview = () => import("./views/PdfPreview.vue");
let TimingPreview = () => import("./views/TimingPreview.vue");
let UserList = () => import("./views/UserList.vue");
let StoreList = () => import("./views/StoreList.vue");
let ValueList = () => import("./views/ValueList.vue");
let DailyList = () => import("./views/DailyList.vue");
let ValueChart = () => import("./views/ValueChart.vue");
let SH = () => import("./views/SH.vue");
let ShipReportList = () => import("./views/ShipReportList.vue");
Vue.use(Router);

// 解决重复点击路由报错的BUG
const routerOther = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerOther.call(this, location).catch(err => err)
}

let router = new Router({
    mode: "history",

    routes: [
        {
            path: "/html-ship-report-list",
            component: ShipReportList
        },
        {
            path: "/html-daily",
            component: DailyList
        },
        {
            path: "/html-sh",
            component: SH
        },
        {
            path: "/html-value",
            component: ValueList
        },
        {
            path: "/html-store",
            component: StoreList
        },
        {
            path: "/html-user",
            component: UserList
        },
        {
            path: "/",
            component: Main
        },
        {
            path: "/html-login",
            component: Login
        },
        {
            path: "/html-adminlist",
            component: AdminList
        },
        {
            path: "/html-forwardlist",
            component: ForwardList
        },
        {
            path: "/html-forwardfinishlist",
            component: ForwardFinishList
        },
        {
            path: "/html-houselist",
            component: HouseList
        },
        {
            path: "/html-purchaserlist",
            component: PurchaserList
        },
        {
            path: "/html-forwardpreview0",
            component: ForwardPreview0
        },
        {
            path: "/html-forwardpreview1",
            component: ForwardPreview1
        },
        {
            path: "/html-pdfpreview",
            component: PdfPreview
        },
        {
            path: "/html-timingpreview",
            component: TimingPreview
        },
        {
            path: "/html-value-chart",
            component: ValueChart
        },
    ]
});

router.beforeEach((to, from, next) => {

    if (
        !loginState.adminLogined()
        && !to.path.includes("forwardpreview")
        && !to.path.includes("timingpreview")
    ) {
        // 处于未登录状态
        if (to.path != "/html-login") {
            next({ path: "/html-login" });
        } else {
            next();
        }
    } else {
        // 处于登录状态
        next();
    }
});

export default router;
